import { axiosInstance } from '@/rest'

// Orders REST API client

const createOrdersApi = () => {
  return {
    /**
     * List orders for an account
     * @param {string} accountNumber
     * @param {Object} params Query params (order_by, sort_direction, symbol, date_from, date_to, limit, offset, strategy, time_in_force, status[])
     */
    list: (accountNumber, params = {}) => {
      const searchParams = new URLSearchParams()
      Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return
        if (Array.isArray(value)) {
          value.forEach((v) => searchParams.append(key, v))
        } else {
          searchParams.append(key, value)
        }
      })
      return axiosInstance.get(
        `orders/${accountNumber}?${searchParams.toString()}`
      )
    },

    /**
     * Get order details (legs + execution reports)
     * @param {string} orderId
     */
    getDetails: (orderId) => axiosInstance.get(`orders/${orderId}/details`),

    /**
     * Partially update the stored order record (broker, admin and superbroker
     * only). This never
     * reaches the exchange, so it cannot change price or quantity — for that
     * use the order validator's modify endpoint.
     * @param {string} orderId
     * @param {Object} body snake_case fields to patch, e.g. { sub_account_id }
     * @returns {Promise<{ order_id, sub_account_id, newsletter_id, trade_activities_updated }>}
     */
    update: (orderId, body) =>
      axiosInstance.patch(`v2/orders/${orderId}`, body),
  }
}

const ordersApi = createOrdersApi()

export { ordersApi }
